import { useEffect } from "react";

import { useDispatch, useSelector } from "common/utilities/react-redux";
import { useTranslate } from "common/utilities/useTranslate";
import { applyPublicationSearchCriteria, clearPublicationSearchCriteria } from "domains/publication/actions";
import { getPublicationSearchCriteria } from "domains/publication/selectors";
import { TopicFilterModal } from "domains/topicSearchFilter/components/TopicFilterModal";
import { getTopicFilters } from "domains/topicSearchFilter/selectors";

export const TopicPublicationFilterModal = () => {
  const dispatch = useDispatch();
  const translate = useTranslate();
  const searchCriteria = useSelector(getPublicationSearchCriteria);
  const filters = useSelector(getTopicFilters("publications"));

  useEffect(() => {
    dispatch(applyPublicationSearchCriteria());
  }, [dispatch]);

  return (
    <TopicFilterModal
      fields={filters}
      handleApplyFilter={(payload) => () => dispatch(applyPublicationSearchCriteria(payload))}
      handleClear={() => dispatch(clearPublicationSearchCriteria())}
      searchCriteria={searchCriteria}
      title={translate("app.publications.filter.title")}
    />
  );
};
